export interface COIRegistryEntry {
  COIRegistryId: number;
  FirmId: number;
  ClientMasterId: number;
  SECClientId: string;
  SECClientName: string;
  SECClientPartner?: string;
  AffiliateTypeCode: "EN" | "IN";
  AffiliateEntityName?: string;
  AffiliateFirstName?: string;
  AffiliateMiddleName?: string;
  AffiliateLastName?: string;
  RelationshipToSECClient?: string;
  AffiliateIndividualSECClient?: "Y" | "N";
  Comment?: string;
  COIRestriction: "Y" | "N";
  CreatedBy?: string;
  CreatedDate?: string;
  UpdatedBy?: string;
  UpdatedDate?: string;
  Active: "Y" | "N";
}

export interface COIRegistryProps {}

export const AFFILIATE_TYPE_CODES = {
  ENTITY: "EN",
  INDIVIDUAL: "IN",
} as const;
